import { makeRequest } from '../base/axios.ts'

export default {
  //E.g.: http://localhost/api/v1/access?abilities=read,edit&permissionable_type=Timeline&permissionable_id=1http://localhost/api/v1/access?abilities[]=read&abilities[]=edit&permissionable_type=Timeline&permissionable_id=1
  checkAbilities: function (abilities = [], permissionable_type, permissionable_id) {
    const uniqueAbilities = [...new Set(abilities)]
    const params = {
      abilities: uniqueAbilities,
      permissionable_type,
      permissionable_id,
    }
    return makeRequest({
      url: `/api/v1/access`,
      method: 'get',
      params,
      requestId: `check-${permissionable_type}:${permissionable_id}-abilities-${abilities}`,
    })
  },
}
